import React, { createContext, useCallback, useContext, useMemo } from "react";
import ar from "./ar.json";
import en from "./en.json";

export const resources = { ar, en };
export const LANGS = ["ar", "en"];
export const DEFAULT_LANG = "ar";
export const LANG_STORAGE_KEY = "recursosarg_lang";

const I18nContext = createContext({ lang: DEFAULT_LANG, t: (k) => k });

function lookup(dict, key) {
  const parts = key.split(".");
  let node = dict;
  for (let i = 0; i < parts.length; i += 1) {
    if (node === null || node === undefined) return undefined;
    node = node[parts[i]];
  }
  return node;
}

export function I18nProvider({ lang, children }) {
  const safeLang = LANGS.includes(lang) ? lang : DEFAULT_LANG;

  const t = useCallback(
    (key) => {
      const value = lookup(resources[safeLang], key);
      if (value === undefined || value === null) {
        const fallback = lookup(resources[DEFAULT_LANG], key);
        return fallback === undefined || fallback === null ? key : fallback;
      }
      return value;
    },
    [safeLang]
  );

  const value = useMemo(
    () => ({
      lang: safeLang,
      t,
      path: (suffix) => `/${safeLang}${suffix || ""}`,
    }),
    [safeLang, t]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
